export const networks = {
  impactRadius: 1,
  rakuten: 2,
  cj: 3,
  partnerize: 4,
  shareASale: 5,
  pepperjam: 6,
  awin: 7,
  ebay: 8,
};

export const networkIdLabelMap = {
  [networks.impactRadius]: 'impact radius',
  [networks.rakuten]: 'rakuten',
  [networks.cj]: 'commmission junction',
  [networks.partnerize]: 'partnerize',
  [networks.shareASale]: 'shareasale',
  [networks.pepperjam]: 'pepperjam',
  [networks.awin]: 'awin',
  [networks.ebay]: 'ebay',
};

export const networkLabelMap = {
  rakuten: 'Rakuten',
  impactRadius: 'Impact Radius',
  commissionJunction: 'Commission Junction',
  partnerize: 'Partnerize',
  shareASale: 'ShareASale',
  pepperjam: 'Pepperjam',
  awin: 'Awin',
  ebay: 'Ebay',
};
